module.exports = __webpack_public_path__ + "img/kuang_left.7008b155.png";